{{if props.link}} <a href="{{props.link}}" class="{{styles.oy_button}} {{props.size && props.size}} {{props.type && props.type}}">{{include './content.art' $data}} </a>{{else}}<div class="{{styles.oy_button}} {{props.size && props.size}} {{props.type && props.type}}">{{include './content.art' $data}}</div>{{/if}}


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYButton/index.art